const ContactHero = () => {
  return (
    <section className="relative min-h-[60vh] md:min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3bd41ba2ba04b4cffa60e4ae8974b5da.jpg"
          alt="Contact Us for Roofing Services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20 text-center">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 font-['Poppins'] leading-tight">
          Get Your Instant Estimate
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-6 sm:mb-8 px-4">
          Ready to save thousands? Get your free instant estimate and connect with vetted pros in your area — no obligation, no pressure
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4">
          <a
            href="tel:+14793366968"
            className="inline-flex items-center gap-3 px-8 py-4 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors cursor-pointer text-lg font-semibold"
          >
            <i className="ri-phone-line text-2xl"></i>
            Call Now: (479) 336-6968
          </a>
          <a
            href="mailto:info@beyourownroofer.com"
            className="w-full sm:w-auto bg-white text-[#2B5BA6] px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer text-center min-h-[48px] flex items-center justify-center"
          >
            <i className="ri-mail-line mr-2"></i>
            Email Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
